// @flow
/* eslint-disable prefer-template, no-path-concat, import/unambiguous, import/no-commonjs */
/* eslint-disable camelcase */

// const StyleLayer = require('../../style/style_layer.js');
const styleSpec = require('../../style-spec/reference/latest');
const util = require('../../util/util');
const {
    Properties,
    DataConstantProperty,
    DataDrivenProperty,
} = require('../../style/properties');

module.exports.createLercLayer = createLercLayer;

const rasterPaint = {
    "raster-opacity": new DataConstantProperty(styleSpec["paint_raster"]["raster-opacity"]),
    "raster-hue-rotate": new DataConstantProperty(styleSpec["paint_raster"]["raster-hue-rotate"]),
    "raster-brightness-min": new DataConstantProperty(styleSpec["paint_raster"]["raster-brightness-min"]),
    "raster-brightness-max": new DataConstantProperty(styleSpec["paint_raster"]["raster-brightness-max"]),
    "raster-saturation": new DataConstantProperty(styleSpec["paint_raster"]["raster-saturation"]),
    "raster-contrast": new DataConstantProperty(styleSpec["paint_raster"]["raster-contrast"]),
    "raster-fade-duration": new DataConstantProperty(styleSpec["paint_raster"]["raster-fade-duration"]),
};
// class LercStyleLayer extends StyleLayer {

function createLercLayer(name, customProps, StyleLayer) {
    const paintKey = `paint_${name}`;
    const lercPaint = customProps.reduce((paint, propKey) => {
        paint[propKey] = handleCustomProp(styleSpec, paintKey, propKey);
        return paint;
    }, util.extend({}, rasterPaint));
    // lercPaint["raster-colorscale"] = new DataDrivenProperty(styleSpec[paintKey]["raster-colorscale"]);
    const lercProps = { paint: new Properties(lercPaint) };
    return class extends StyleLayer {
        constructor(layer: LayerSpecification) {
            super(layer, lercProps);
        }
    };
}

function handleCustomProp(styleSpec, paintKey, propKey) {
    if (propKey === 'raster-colorscale') {
        // return new DataConstantProperty(styleSpec[paintKey][propKey]);
        return new DataDrivenProperty(styleSpec[paintKey][propKey]);

    }
    return new DataConstantProperty(styleSpec[paintKey][propKey]);
}

